import { ICreateService, IService } from "../types/service";
import { apiClient } from "./client";

export const Service = {
  create: (data: ICreateService) =>
    apiClient.post<IService>("/services", data),
  update: (id: string, data: ICreateService) =>
    apiClient.put<IService>(`/services/${id}`, data),
  delete: (id: string) =>
    apiClient.delete<any>(`/services/${id}`),
}